<ui-tab-links [items]="tabs$ | async"></ui-tab-links>
